import React from "react";

import i18n from "../../../../constants/i18n";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Date from "../../../../core/et3-input/et3-date";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getSilentBannedUsersStore from "../../../../stores/user-store/silent-banned-store";

const SilentlyBannedUsersForm = withLiteObserverAndTheme(() => {
  return (
    <React.Fragment>
      <Et3Date
        label={i18n.get("FROM_DATE")}
        hasMax={false}
        hasMin={false}
        dateInputObservable={getSilentBannedUsersStore().fromDateInput}
        isEnabled={true}
      />
      <Et3Margin top={20} bottom={0} left={0} right={0} />
      <Et3Date
        label={i18n.get("TO_DATE")}
        hasMax={false}
        hasMin={false}
        dateInputObservable={getSilentBannedUsersStore().toDateInput}
        isEnabled={true}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={true}
        onClick={async () => {
          await getSilentBannedUsersStore().getSilentBannedUsers();
        }}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </React.Fragment>
  );
});
export default SilentlyBannedUsersForm;
